import { Component, Input, OnInit, Type, ViewChild } from '@angular/core';
import { DynamicInputComponent, MenuGroup } from '../../dynamic-input-model';
import { EditorService } from '../../services/editor.service';
import { NbDialogRef, NbDialogService, NbMenuItem, NbMenuService, NbPopoverDirective, NbPosition, NbTabComponent } from '@nebular/theme';
import { HomeInputGridComponent } from './home-input-grid/home-input-grid.component';
import { HomeInputBannerComponent } from './home-input-banner/home-input-banner.component';
import { HomeProductListComponent } from './home-product-list/home-product-list.component';
import { HomeInputFeaturesComponent } from './home-input-features/home-input-features.component';
import { HomeInputTestimonialsComponent } from './home-input-testimonials/home-input-testimonials.component';
import { HomeInputBloglistComponent } from './home-input-bloglist/home-input-bloglist.component';
import { HomeInputHeroImageComponent } from './home-input-hero-image/home-input-hero-image.component';

@Component({
  selector: 'ngx-home-input',
  templateUrl: './home-input.component.html',
  styleUrls: ['./home-input.component.scss']
})
export class HomeInputComponent implements OnInit {
  @Input() data: any;
  defaultMenuTag: string;
  topLevelMenuTag = "editHomePageRouteMenu";
  activeInputMenuItem: string;
  defaultInputMenuItem: string;
  menuItemTitle: string;
  menuGroups: any;

  constructor(private editorService: EditorService,
    private menuService: NbMenuService,
    private dialogService: NbDialogService) { }

  ngOnInit(): void {
    console.log(this.data);
    this.menuGroups = this.data;
    const topLevelMenu: MenuGroup = this.menuGroups["topLevelMenu"];
    let dialogRef: NbDialogRef<any>;
    if (topLevelMenu != undefined) {
      this.defaultMenuTag = topLevelMenu.menuTag;
      this.defaultInputMenuItem = topLevelMenu.menuItems[0].title;
      this.activeInputMenuItem = this.defaultInputMenuItem;
    }
    this.menuService.onItemClick().subscribe(menuBag => {
      console.log({ menuBag: menuBag });
      const selectedItem = menuBag.item;
      if (selectedItem != undefined) {
        // if(selectedItem.parent.title)
        console.log({ selectedItem: selectedItem });
        this.activeInputMenuItem = selectedItem.title;
        let component: Type<any>;
        switch (selectedItem.title) {
          case "Grid":
            component = HomeInputGridComponent;
            dialogRef = this.dialogService.open(component, {
              dialogClass: "grid-picker",
              hasBackdrop: false,
              context: {
                title: "Fokof",
                dialogWidth: 960
              },
            })
            break;
          case "Banner":
            component = HomeInputBannerComponent;
            dialogRef = this.dialogService.open(component, {
              dialogClass: "grid-picker",
              hasBackdrop: false,
              context: {
                title: "Fokof",
                dialogWidth: 960
              },
            })
            break;
          case "Product List":
            component = HomeProductListComponent;
            dialogRef = this.dialogService.open(component, {
              dialogClass: "grid-picker",
              hasBackdrop: false,
              context: {
                title: "Fokof",
                dialogWidth: 960,
              },
            })
            break;
          case "Feature List":
            component = HomeInputFeaturesComponent;
            dialogRef = this.dialogService.open(component, {
              dialogClass: "grid-picker",
              hasBackdrop: false,
              context: {
                title: "Fokof",
                dialogWidth: 960,
              },
            })
            break;
          case "Testimonials":
            component = HomeInputTestimonialsComponent;
            dialogRef = this.dialogService.open(component, {
              dialogClass: "grid-picker",
              hasBackdrop: false,
              context: {
                title: "Fokof",
                dialogWidth: 960,
              },
            })
            break;
          case "Blog List":
            component = HomeInputBloglistComponent;
            dialogRef = this.dialogService.open(component, {
              dialogClass: "grid-picker",
              hasBackdrop: false,
              context: {
                title: "Fokof",
                dialogWidth: 960,
              },
            })
            break;
          case "Hero Image":
            component = HomeInputHeroImageComponent;
            dialogRef = this.dialogService.open(component, {
              dialogClass: "grid-picker",
              hasBackdrop: false,
              context: {
                title: "Fokof",
                dialogWidth: 960,
              },
            })
            break;
          default:
            break;
        }
      }
    })
    if (dialogRef !== undefined) {
      dialogRef.onClose.subscribe(() => {
        console.log("Dialog closed");
        this.activeInputMenuItem = this.defaultInputMenuItem;
      });
    }
  }

  tabChanged(e: NbTabComponent) {
    if (e.tabTitle == "Sections") {

    }
  }


}
